import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { BtText } from '@linqpal/components/src/ui'
import { PaymentMethodItem } from '../components'
import { AddNewButton } from '../../../../../ui/add-payment-method-components'
import { Invoice } from '../InvoiceDetails'
import RootStore from '../../../../../store'
import { EInvoiceType } from '@linqpal/models'
import { StyleSheet } from 'react-native'
import { useTranslation } from 'react-i18next'

interface IPaymentMethodsListProps {
  acceptAchPayment: boolean
  invoice: Invoice
  onSelection: (method: any) => void
}

export const PaymentMethodsList: FC<IPaymentMethodsListProps> = observer(
  ({ acceptAchPayment, invoice, onSelection }) => {
    const paymentMethodsStore = RootStore.screensStore.paymentMethodsStore

    const { t } = useTranslation('global')

    const isReadOnly = invoice.type === EInvoiceType.QUOTE

    const methods = acceptAchPayment
      ? paymentMethodsStore.paymentMethods
      : paymentMethodsStore.paymentMethods.filter(
          (method) => method.paymentMethodType !== 'bank',
        )

    return (
      <>
        {isReadOnly && !!methods.length && (
          <BtText style={styles.quoteHeader}>
            {t('InvoiceDetails.connected-accounts')}
          </BtText>
        )}

        {methods.map((method) => (
          <PaymentMethodItem
            key={method.id}
            item={method}
            canPay={!isReadOnly}
            onPaymentSelection={onSelection}
          />
        ))}

        {!isReadOnly && <AddNewButton />}
      </>
    )
  },
)

const styles = StyleSheet.create({
  quoteHeader: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 16,
    fontWeight: '600',
    color: '#003353',
    lineHeight: 28,
    paddingBottom: 15,
    textAlign: 'center',
  },
})
